export default __webpack_public_path__ + "static/media/HbFooterLeft1.62140dba.svg";